import { useEffect, useRef, useState } from "react";
import { LayoutTemplate } from "lucide-react";

import styles from "./TemplateSectionPicker.module.css";

export const SECTION_DIVIDER_RULE =
  '<hr style="border:none;border-top:1px dashed #d1d5db;margin:12px 0;"/>';

const buildSection = (label) => {
  const divider =
    `<p style="text-align:center;margin:0;"><strong>— ${label} —</strong></p>`;
  const placeholder = `<p style="color:#9ca3af;"><em>Type the ${label.toLowerCase()} content here…</em></p>`;

  return `${divider}${placeholder}<p><br></p>`;
};

const SECTION_OPTIONS = [
  {
    id: "header",
    label: "Header",
    description: "Centered divider + header placeholder",
    build: () => `${buildSection("Header")}${SECTION_DIVIDER_RULE}`,
  },
  {
    id: "body",
    label: "Body",
    description: "Centered divider + body placeholder",
    build: () => `${SECTION_DIVIDER_RULE}${buildSection("Body")}${SECTION_DIVIDER_RULE}`,
  },
  {
    id: "footer",
    label: "Footer",
    description: "Centered divider + footer placeholder",
    build: () => `${SECTION_DIVIDER_RULE}${buildSection("Footer")}`,
  },
  {
    id: "full",
    label: "Full skeleton",
    description: "Header + Body + Footer, all at once",
    build: () =>
      `${buildSection("Header")}${SECTION_DIVIDER_RULE}${buildSection(
        "Body"
      )}${SECTION_DIVIDER_RULE}${buildSection("Footer")}`,
  },
];

export const TemplateSectionPicker = ({ onInsert }) => {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const handlePick = (option) => {
    onInsert(option.build());
    setIsOpen(false);
  };

  return (
    <div className={styles.container}>
      <button
        ref={buttonRef}
        type="button"
        className={styles.triggerButton}
        onClick={() => setIsOpen((previous) => !previous)}
      >
        <LayoutTemplate size={16} />
        Insert Section
      </button>

      {isOpen && (
        <div ref={dropdownRef} className={styles.dropdown}>
          <ul className={styles.list}>
            {SECTION_OPTIONS.map((option) => (
              <li key={option.id}>
                <button
                  type="button"
                  className={styles.item}
                  onClick={() => handlePick(option)}
                >
                  <span className={styles.itemLabel}>{option.label}</span>
                  <span className={styles.itemDescription}>
                    {option.description}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
